import request from "@/router/axios";

export const getList = (current, size, params) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/list",
        method: "get",
        params: {
            ...params,
            current,
            size,
        },
    });
};

export const getDetail = (id) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/detail",
        method: "get",
        params: {
            id,
        },
    });
};

export const remove = (ids) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/remove",
        method: "post",
        params: {
            ids,
        },
    });
};

export const add = (row) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/submit",
        method: "post",
        data: row,
    });
};

export const update = (row) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/submit",
        method: "post",
        data: row,
    });
};

//flowableDoingPage
export const flowableDoingPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanInformation/loanInformation/loan-doing-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


export const normalUploadImages = (file) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/normal-upload-images",
        method: "post",
        data: (function(file) {
            var form = new FormData();
            form.append("file", file);
            return form;
        })(file),
    });
};

export const uploadImages = (file, type) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/upload-images",
        method: "post",
        data: (function(file, type) {
            var form = new FormData();
            form.append("file", file);
            if(type) form.append("type", type);
            return form;
        })(file, type),
    });
};

export const uploadImagesWithOCR = (file, type) => {
    return request({
        url: "/api/blade-loanInformation/loanInformation/upload-images-with-ocr",
        method: "post",
        data: (function(file, type) {
            var form = new FormData();
            form.append("file", file);
            form.append("type", type);
            return form;
        })(file, type),
    });
};

export const importExcel = (file, type) => {
  return request({
      url: "/api/blade-loanCredentialManagement/loanCredentialManagement/import-excel",
      method: "post",
      data: (function(file, type) {
          var form = new FormData();
          form.append("file", file);
          form.append("type", type);
          return form;
      })(file, type),
  });
};

export const flowableBpmnImage = (id) => {
    return request({
        url: `/api/blade-flowable/flowable-bpmn-image/${id}`,
        method: "get",
    });
};

export const deptPingguAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-pinggu-audit/${operatorType}`,
        method: "post",
        data: data,
    });
};

//deptKefuAudit
export const deptKefuAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-audit/${operatorType}`,
        method: "post",
        data: data,
    });
};

///group-pinggu-audit
export const groupPingguAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-pinggu-audit/${operatorType}`,
        method: "post",
        data: data,
    });
};
//yewuyuan-confirm
export const yewuyuanConfirm = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/yewuyuan-confirm/${operatorType}`,
        method: "post",
        data: data,
    });
};

//fengkongFaceAudit
export const fengkongFaceAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/fengkong-face-audit/${operatorType}`,
        method: "post",
        data: data,
    });
};



//deptKefuCommit
export const deptKefuCommit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/new-dept-kefu-commit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//groupFengkongAudit
export const groupFengkongAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-fengkong-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//deptYewuyuanEndConfirm
export const deptYewuyuanEndConfirm = (data, operatorType) => {
        return request({
            url: `/api/blade-loanInformation/loanInformation/dept-yewuyuan-end-confirm/${operatorType}`,
            method: "post",
            data: data,
        });
    }
    //deptKefuSubmitMaiMaiContract
export const kefuSubmitMaiMaiContract = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-submit-maimai-contract/${operatorType}`,
        method: "post",
        data: data,
    });
}

//kefuSubmitDiyaContract
export const kefuSubmitDiyaContract = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-submit-diya-contract/${operatorType}`,
        method: "post",
        data: data,
    });
}

//caozuoyuanGuohu
export const caozuoyuanGuohu = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caozuoyuan-guohu/${operatorType}`,
        method: "post",
        data: data,
    });
}

//caozuoyuanGuohu
export const caozuoyuanGuohuAgain = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caozuoyuan-guohu-again/${operatorType}`,
        method: "post",
        data: data,
    });
}

//caozuoyuanDiya
export const caozuoyuanDiya = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caozuoyuan-diya/${operatorType}`,
        method: "post",
        data: data,
    });
}

//caozuoyuanDiya
export const caozuoyuanDiyaAgain = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caozuoyuan-diya-again/${operatorType}`,
        method: "post",
        data: data,
    });
}

//xinshenGuohuAudit
export const xinshenGuohuAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-guohu-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

export const xinshenGuohuAuditAgain = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-guohu-audit-again/${operatorType}`,
        method: "post",
        data: data,
    });
}


//xinshenDiyaAudit
export const xinshenDiyaAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-diya-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}
// 办理抵押
export const createOrderAudit = (data) => {
    return request({
        url: `/api/chequantong/createOrder`,
        method: "post",
        data: data,
    });
}

export const xinshenDiyaAuditAgain = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-diya-audit-again/${operatorType}`,
        method: "post",
        data: data,
    });
}

//installGps
export const installGps = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/install-gps/${operatorType}`,
        method: "post",
        data: data,
    });
}

//gpsAudit
export const gpsAgainAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/gps-again-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//caiwuLending
export const caiwuLending = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caiwu-lending/${operatorType}`,
        method: "post",
        data: data,
    });
}

//kefuAddLendingData
export const kefuAddLendingData = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/kefu-add-lending-data/${operatorType}`,
        method: "post",
        data: data,
    });
}

//fengkongLendingAudit
export const fengkongLendingAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/fengkong-lending-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

export const che300CarDataTree = (params) => {
    return request({
        url: `/api/blade-che300CarData/che300CarData/tree`,
        method: "get",
        params: params
    });
}

//do-generator-che300-car-price
export const doGeneratorChe300CarPrice = (params) => {
    return request({
        url: `/api/blade-che300CarData/che300CarData/do-generator-che300-car-price`,
        method: "post",
        data: params
    });
}


export const doGeneratorBigdataPdf = (params) => {
        return request({
            url: `/api/blade-bigdataPdfGeneratorRecord/bigdataPdfGeneratorRecord/do-generator-bigdata-pdf-new`,
            method: "get",
            params: params
        });
    }
    // API生成征信报告记录
export const createCreditInvestigationRecord = (params) => {
        return request({
            url: `/api/blade-creditInvestigationRecord/creditInvestigationRecord/createCreditInvestigationRecord`,
            method: "get",
            params: params
        });
    }
    // 根据客户ID查询征信报告记录
export const checCreditInvestigationRecord = (params) => {
        return request({
            url: `/api/blade-creditInvestigationRecord/creditInvestigationRecord/checkRecord`,
            method: "get",
            params: params
        });
    }
    // API生成车辆维修记录
export const createMaintenanceRecord = (params) => {
        return request({
            url: `/api/blade-che300MaintenanceRecord/che300MaintenanceRecord/createMaintenanceRecord`,
            method: "post",
            data: params
        });
    }
    // 根据客户ID查询车辆维修记录
export const checkMaintenanceRecord = (params) => {
        return request({
            url: `/api/blade-che300MaintenanceRecord/che300MaintenanceRecord/checkRecord`,
            method: "get",
            params: params
        });
    }
    // API生成车辆保险记录
export const createInsuranceRecord = (params) => {
        return request({
            url: `/api/blade-che300InsuranceRecord/che300InsuranceRecord/createInsuranceRecord`,
            method: "post",
            data: params
        });
    }
    // 根据客户ID查询车辆保险记录
export const checkInsuranceRecord = (params) => {
    return request({
        url: `/api/blade-che300InsuranceRecord/che300InsuranceRecord/checkRecord`,
        method: "get",
        params: params
    });
}

///simple-detail-for-repayment-plan
export const simpleDetailForRepaymentPlan = (loanInformationId) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/simple-detail-for-repayment-plan`,
        method: "get",
        params: {
            id: loanInformationId
        }
    });
}

//additionalMaterials
export const additionalMaterials = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/additional-materials`,
        method: "post",
        data: data,
    });
}


//chengliFengkongAudit
export const chengliFengkongAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/chengli-fengkong-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//flowable-done-page
export const flowableDonePage = (current, size, params) => {
    return request({
        url: '/api/blade-loanInformation/loanInformation/customer-list',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//doAddGpsData
export const doAddGpsData = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/do-add-gps-data`,
        method: "post",
        data: data,
    });
}

//doDeleteGpsData
export const doDeleteGpsData = (id) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/do-delete-gps-data/${id}`,
        method: "post",
    });
}

//chulipinKefuSubmitMaiMaiContract
export const chulipinKefuSubmitMaiMaiContract = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/chulipin-kefu-submit-maimai-contract/${operatorType}`,
        method: "post",
        data: data,
    });
}


//xinshenDiyaContractAudit
export const xinshenDiyaContractAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-diya-contract-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//xinshenMaimaiContractAudit
export const xinshenMaimaiContractAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-maimai-contract-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//fengkongMaimaiContractAudit
export const fengkongMaimaiContractAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/fengkong-maimai-contract-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//xinshenZulinContractAudit
export const xinshenZulinContractAudit = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-zulin-contract-audit/${operatorType}`,
        method: "post",
        data: data,
    });
}

//kefuSubmitZulinContract
export const kefuSubmitZulinContract = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/kefu-submit-zulin-contract/${operatorType}`,
        method: "post",
        data: data,
    });
}

//xinshenConfirmLendingType
export const xinshenConfirmLendingType = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/xinshen-confirm-lending-type/${operatorType}`,
        method: "post",
        data: data,
    });
}

//deptKefuConfirmLendingType
export const deptKefuConfirmLendingType = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-conform-lending-type/${operatorType}`,
        method: "post",
        data: data,
    });
}


//download-all
export const downloadAll = (loanInformationId) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/download-all`,
        method: "get",
        params: {
            id: loanInformationId
        },
    });
}


//old-information-detail
export const oldInformationDetail = (loanInformationId) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/old-information-detail`,
        method: "get",
        params: {
            id: loanInformationId
        },
    });
}

//updateOldInformation
export const updateOldInformation = (data, resetRepaymentPlan) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/update-old-information`,
        method: "post",
        data: data,
    });
}

//caiwuLendingEnd
export const caiwuLendingEnd = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/caiwu-lending-end/${operatorType}`,
        method: "post",
        data: data,
    });
}

//blade-loanInformation/loanInformation/break-node-any-point
export const breakNodeAnyPoint = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/break-node-any-point`,
        method: "post",
        data: data,
    });
}


//dept_kefu_add_lending_image/{operatorType}
export const deptKefuAddLendingImage = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept_kefu_add_lending_image/${operatorType}`,
        method: "post",
        data: data,
    });
}



///group_end_audit_lending_type/{operatorType}
export const groupEndAuditLendingType = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group_end_audit_lending_type/${operatorType}`,
        method: "post",
        data: data,
    });
}


//group-yunying-speical-lengding-amount
export const groupYunyingSpeicalLengdingAmount = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-yunying-special-lengding-amount/${operatorType}`,
        method: "post",
        data: data,
    });
}


///group-yunying-speical-audit-car
export const doGroupYunyingSpeicalAuditCar = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-yunying-special-audit-car/${operatorType}`,
        method: "post",
        data: data,
    });
}
///doStart
export const doStart = (data) => {
  return request({
      url: `/api/blade-special/specialApproval/start`,
      method: "post",
      data: data,
  });
}

//group-kuaiji-audit-lending-data/{operatorType}
export const groupKuaijiAuditLendingData = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-kuaiji-audit-lending-data/${operatorType}`,
        method: "post",
        data: data,
    });
}

//group-audit-modify-diya-contract-info/{operatorType}
export const groupAuditModifyDiyaContractInfo = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-audit-modify-diya-contract-info/${operatorType}`,
        method: "post",
        data: data,
    });
}

//group-audit-modify-zulin-contract-info/{operatorType}
export const groupAuditModifyZulinContractInfo = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/group-audit-modify-zulin-contract-info/${operatorType}`,
        method: "post",
        data: data,
    });
}

//dept-kefu-modify-diya-contract-info/{operatorType}
export const deptKefuModifyDiyaContractInfo = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-modify-diya-contract-info/${operatorType}`,
        method: "post",
        data: data,
    });
}

//dept-kefu-modify-zulin-contract-info/{operatorType}
export const deptKefuModifyZulinContractInfo = (data, operatorType) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/dept-kefu-modify-zulin-contract-info/${operatorType}`,
        method: "post",
        data: data,
    });
}


///can-assignee-user-list
export const canAssigneeUserList = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/can-assignee-user-list`,
        method: "post",
        data: data,
    });
}

//assignee-to-user
export const assigneeToUser = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/assignee-to-user`,
        method: "post",
        data: data,
    });
}

//export
export const exportLoanInformation = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/export`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}


//transfer-user-list
export const transferUserList = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/transfer-user-list`,
        method: "post",
        data: data,
    });
}


//export-loan-done
export const exportLoanDone = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/export-loan-done`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}

export const exportLentCustomers = (data) => {
    return request({
        url: `/api/blade-loanInformation/loanInformation/export-LentCustomers`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}

export const deptKefuConformPayFirst = (data,operatorType) => {
  return request({
      url: `/api/blade-loanInformation/loanInformation/dept-kefu-conform-pay-first`,
      method: "post",
      data: data,
  });
}

export const kefuConformPayFirstAudit = (data, operatorType) => {
  return request({
      url: `/api/blade-loanInformation/loanInformation/dept-kefu-conform-pay-first-audit/${operatorType}`,
      method: "post",
      data: data,
  });
}

// 客户列表 存量客户 转诉讼
export const customerNegotiationsTransfer = (data) => {
  return request({
      url: `/api/v2/blade-loanPost/loan/customerNegotiationsTransfer`,
      method: "post",
      data: data,
  });
}

// 客户列表 存量客户 转诉讼
export const customerSave = (data) => {
  return request({
      url: `/api/blade-loanInformation/loanInformation/customer-save`,
      method: "post",
      data: data,
  });
}

export const lazyTrer= (parentCode='00')=>{
    return request({
        url:`/api/blade-system/region/lazy-tree?parentCode=${parentCode}`,
        method:'get',
    })
}

export const createCreditInvestigationRecordApi= (data)=>{
    return request({
        url:`/api/blade-creditInvestigationRecord/creditInvestigationRecord/createCreditInvestigationRecord`,
        method:'post',
        data:data
    })
}

export const checkRecordApi= (params)=>{
  console.log(params,'params')
    return request({
        url:`/api/blade-creditInvestigationRecord/creditInvestigationRecord/checkRecord`,
        method:'get',
        params:params
    })
}


/**
 * 授权书
 * taskDefinitionKey    id    cardNo    name     phoneNumber 
 */
export const getAuthorizationBook = (params) => {
    return request({
        url: `/api/blade-bigdataPdfGeneratorRecord/bigdataPdfGeneratorRecord/do-generator-bigdata-pdf-incoming-verification`,
        method: "get",
        params: params,
    });
}